import { render, staticRenderFns } from "./EventPriceDetails.vue?vue&type=template&id=48c59463&scoped=true&"
import script from "./EventPriceDetails.vue?vue&type=script&lang=ts&"
export * from "./EventPriceDetails.vue?vue&type=script&lang=ts&"
import style0 from "./EventPriceDetails.vue?vue&type=style&index=0&id=48c59463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c59463",
  null
  
)

export default component.exports